import api from '../../utils/axios';
import { API_ROUTES } from '../../constants/apiRoutes';

export const getJobApplicationsListApi = async ({
  pageNumber,
  searchValue,
  sortBy,
  orderBy,
  fromHr,
  size,
  technology,
  minExp,
  maxExp,
  location,
  status
}) => {
  try {
    const response = await api.get(
      `${API_ROUTES.CANDIDATE_JOB_APPLICATIONS}?page=${pageNumber}${
        status?.code === 5 ? `&searchComment=${searchValue}` : `&searchName=${searchValue}`
      }&sortBy=${sortBy}&orderBy=${orderBy}&size=${size}&fromHr=${fromHr}&technologies=${technology}${
        minExp !== null ? `&minExp=${minExp}` : ''
      }${maxExp !== null ? `&maxExp=${maxExp}` : ''}&location=${location?.code || ''}&status=${
        status?.code || ''
      }`
    );
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const appliedJobStatusApi = async (payload) => {
  try {
    const response = await api.put(
      `${API_ROUTES.CANDIDATE_JOB_APPLICATIONS_STATUS}/${payload.id}`,
      {
        Status: payload.Status,
        comment: payload.Comment
      }
    );
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const updateMatchingPercentageApi = async (candidateId) => {
  try {
    const response = await api.get(`/v1/candidate/update-matching-percentage/${candidateId}`);
    return response;
  } catch (error) {
    throw new Error(error);
  }
};
